import { render, staticRenderFns } from "./GraphIcon.vue?vue&type=template&id=ac47ebd0&"
import script from "./GraphIcon.vue?vue&type=script&lang=ts&"
export * from "./GraphIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ac47ebd0', component.options)
    } else {
      api.reload('ac47ebd0', component.options)
    }
    module.hot.accept("./GraphIcon.vue?vue&type=template&id=ac47ebd0&", function () {
      api.rerender('ac47ebd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/GraphIcon.vue"
export default component.exports